// extracted by mini-css-extract-plugin
export var container = "_sb-0";
export var inputWidth = "_sb-1";